import { createAction } from "redux-actions";

import { createAsyncAction } from "../helpers";

export const getContactsListAsyncAction = createAsyncAction(
	"GET_CONTACTS_LIST_REQUEST",
	"GET_CONTACTS_LIST_SUCCESS",
	"GET_CONTACTS_LIST_FAILURE",
	"GET_CONTACTS_LIST_CANCEL"
);

export const resetAction = createAction("CONTACTS_RESET_ACTIONS");
